<template>
    <li v-if="showReminderSMSInformation">
        {{ delayValue }}h {{ $t('coupon.reminderSMS') }} {{ formattedCellphone }}
    </li>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatPhoneNumber } from '@/utils';
import { EstablishmentSetting } from '@/enums';

export default {
    name: 'coupon-reminder-sms',
    props: {
        appointment: { type: Object, required: true },
        confirmation: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            getCommunications: 'establishment/getCommunications',
            getEstablishmentSettingById: 'establishment/getEstablishmentSettingById',
        }),

        /**
         * Returns the delay in hours
         */
        delayValue() {
            return this.confirmation.delay / 60;
        },

        /**
         * Return the cellphone in the format (###) ###-#### or an empty string
         */
        formattedCellphone() {
            return this.appointment.clientData.cellphone
                ? formatPhoneNumber(this.appointment.clientData.cellphone)
                : '';
        },

        /**
         * Validate the display of SMS information for the reminder
         */
        showReminderSMSInformation() {
            return this.confirmation &&
                this.confirmation.sendSms &&
                this.appointment.clientData.cellphone &&
                this.smsEnabled;
        },

        /**
         * Returns true if the SMS option is enable for the establishment
         */
        smsEnabled() {
            return this.getEstablishmentSettingById(EstablishmentSetting.ENABLE_SMS);
        },
    },
};
</script>
